// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-authors-js": () => import("./../src/pages/authors.js" /* webpackChunkName: "component---src-pages-authors-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-author-page-js": () => import("./../src/templates/authorPage.js" /* webpackChunkName: "component---src-templates-author-page-js" */),
  "component---src-templates-doc-js": () => import("./../src/templates/doc.js" /* webpackChunkName: "component---src-templates-doc-js" */)
}

